export default __webpack_public_path__ + "static/media/chart.65ccd518.png";